module.exports = __webpack_public_path__ + "static/books-123098e073a4ba0683625e1b33d69ecd.svg";